import { all, call, put, takeLatest } from 'redux-saga/effects';
import { api } from 'services';
import {
  ASYNC_USER_LOGIN,
  ASYNC_USER_LOGOUT,
  ASYNC_USER_LOAD_DATA,
  AUTH_ERROR,
  USER_UNAUTH,
  USER_AUTH,
  CLEAR_AREA,
  LOADING
} from 'store';

function* userLogin(action) {
  const {
    payload: { email, password }
  } = action;

  yield put({ type: LOADING, payload: true });

  try {
    const response = yield call(api.post, 'auth/login', { email, password });
    const data = yield response.data;

    yield localStorage.setItem('token', data.access_token);
    yield localStorage.setItem('user', JSON.stringify(data.user));

    yield put({ type: USER_AUTH });
    yield put({ type: ASYNC_USER_LOAD_DATA });
  } catch (error) {
    yield put({
      type: AUTH_ERROR,
      payload: 'Invalid Credentials!',
      resp: error.response
    });
  } finally{
    yield put({ type: LOADING, payload: false });
  }
}

function* userLogout() {
  yield call(api.get, 'auth/logout');
  yield localStorage.removeItem('token');
  yield localStorage.removeItem('user');
  yield put({ type: USER_UNAUTH });
  yield put({ type: CLEAR_AREA });
}

export default function* root() {
  yield all([
    takeLatest(ASYNC_USER_LOGIN, userLogin),
    takeLatest(ASYNC_USER_LOGOUT, userLogout)
  ]);
}
